import { Person } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/** Who the top bar greets: the Display Name, else the username. */
export function welcomeName(
  firstName?: string | null,
  username?: string | null,
): string {
  return (firstName ?? "").trim() || (username ?? "").trim() || "Client";
}

interface TopBarAccountProps {
  name: string;
  /** The id of the account menu the button opens. */
  menuId: string;
  menuOpen: boolean;
  onOpenMenu: (anchor: HTMLElement) => void;
}

/**
 * The right side of the top bar, the same for everyone in both shells: the
 * greeting (from 600 px, cut with an ellipsis) and the account menu button.
 */
export default function TopBarAccount({
  name,
  menuId,
  menuOpen,
  onOpenMenu,
}: TopBarAccountProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 1,
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          display: { xs: "none", sm: "block" },
          color: "#fff",
          ...theme.typography.calibrateShell,
          fontWeight: 500,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        Welcome, {name}!
      </Typography>
      <IconButton
        aria-label="Account menu"
        aria-controls={menuOpen ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
        onClick={(event) => onOpenMenu(event.currentTarget)}
        size="small"
        sx={{
          flexShrink: 0,
          p: 0,
          width: 40,
          height: 40,
          borderRadius: "50%",
          border: "none",
          boxShadow: "none",
          bgcolor: "calibrate.iconOnTeal",
          "&:hover": { bgcolor: "#d4eef5" },
        }}
      >
        <Person sx={{ fontSize: 26, color: "primary.main" }} />
      </IconButton>
    </Box>
  );
}
